import React, { useState } from "react";
import {
  Alert,
  Button,
  Card,
  Col,
  Input,
  notification,
  Row,
  // Space,
  Typography,
} from "antd";
import catchErrorFunction from "../../../utils/tms-catch-error/tms-catch-error";
import { withRouter } from "../../../utils/tms-with-router/tms-with-router";
import moment from "moment";
import { DutyServices } from "../../../services/duty-pass.service";
const DutyPassScan = ({ router }) => {
  const [loading, setLoading] = useState(false);
  const [ticketId, setTicketId] = useState();
  const [data, setData] = useState();
  const [valid, setValid] = useState(false);
  const [errMessage, setErrMessage] = useState();
  const renderTicket = (data) => {
    const datas = [
      {
        title: "Duty Pass ID",
        value: <b>{data?.id}</b>,
      },
      {
        title: "Name",
        value: data?.name,
      },
      {
        title: "Department",
        value: data?.department?.departmentName,
      },
      {
        title: "Category",
        value: data?.category?.categoryName,
      },
      {
        title: "Desgination",
        value: data?.designation,
      },
      {
        title: "Created At",
        value: moment(data?.createdAt).format("DD-MM-YYYY hh:mm:ss A"),
      },
      {
        title: "Updated At",
        value: moment(data?.updatedAt).format("DD-MM-YYYY hh:mm:ss A"),
      },
    ];
    return datas.map((item, index) => {
      return (
        <Row style={{ marginBottom: "5px" }} key={"ticketdetails" + index}>
          <Col className="ticket_label">{item.title}:</Col>
          <Col className="ticket_data">{item?.value}</Col>
        </Row>
      );
    });
  };

  const ticketScan = async () => {
    setValid(false);
    setErrMessage(undefined);
    setLoading(true);
    if (!ticketId) {
      notification.error({ message: "Enter Duty pass ID!" });
    }

    try {
      const data = await DutyServices.scanDutyPass(ticketId);
      if (data) {
        setData(data?.data);
      }
      setTicketId("");
      if (!data?.success) {
        setErrMessage(data?.message);
      }
      setValid(data?.success);
      setLoading(false);
    } catch (error) {
      if (error?.response?.data?.message) {
        setValid(false);
        setErrMessage(error?.response?.data?.message);
      }
      setTicketId("");
      catchErrorFunction(error, "Token expired!! Login again.", router);
      setLoading(false);
    }
  };

  const onChangeTicketId = (e) => {
    setTicketId(e.target.value);
    setValid(false);
    setErrMessage(undefined);
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      ticketScan();
    }
  };

  return (
    <>
      <Row justify="center">
        <Typography.Title> Duty Pass Scan </Typography.Title>
      </Row>
      <Row justify="center">
        <Col
          className="mobile-responsive-width"
          style={{ margin: "8px", textAlign: "left" }}
        >
          {" "}
          Duty Pass Id:{" "}
        </Col>
        <Col className="mobile-responsive-width" style={{ margin: "8px" }}>
          <Input
            maxLength={220}
            value={ticketId}
            onChange={onChangeTicketId}
            onKeyDown={onKeyDown}
            className="mobile-responsive-width"
          />
        </Col>
        <Col className="mobile-responsive-width" style={{ margin: "8px" }}>
          <Button
            className="mobile-responsive-width"
            type="primary"
            onClick={ticketScan}
            loading={loading}
          >
            GO!
          </Button>
        </Col>
      </Row>
      <Row justify="center" style={{ margin: "20px" }}>
        {valid && data && (
          <Alert
            message={`Tag Scanned ${data?.[0]?.ticketId ?? ""}`}
            description={`Tag has been scanned successfully.`}
            type="success"
            showIcon
          />
        )}
        {!valid && errMessage && (
          <Alert
            style={{
              paddingRight: "30px",
              backgroundColor: "red",
              color: "white",
              height: "150px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "20px",
              padding: "25px",
            }}
            message={
              <span
                style={{
                  color: "white",
                  fontSize: "30px",
                }}
              >
                Error Scanning Ticket {data?.[0]?.ticketId ?? ""}
              </span>
            }
            description={errMessage}
            type="error"
          />
        )}
      </Row>
      {valid && data && (
        <Row>
          <Col span={12} style={{ textAlign: "left", fontSize: "14px" }}>
            <Card>{renderTicket(data)} </Card>
          </Col>
          <Col span={12} style={{ padding: "0px 10px", fontSize: "14px" }}>
            <Card>
              <img src={data?.photoUrl} alt="" />
            </Card>
          </Col>
        </Row>
      )}
    </>
  );
};

export default withRouter(DutyPassScan);
